import { useEffect, useState } from 'react'

import { AvatarProfile, AvatarSize } from '@/Atomic/Atoms/AvatarProfile'
import {
  DataBinary,
  dataBinaryToUrl,
  isDataBinary,
} from '@/utils/dataBinaryToUrl'
import { isString } from '@/utils/isString'

interface AvatarProps {
  avatar?: string | DataBinary
  icon?: string
  size?: AvatarSize
  initials?: string
  /**
   * Stable value used to choose the initials background color. Required when
   * `initials` is provided.
   *
   * Pass the entity ID so the same entity keeps the same color across renders.
   */
  initialsColorSeed?: string
  className?: string
}

export const Avatar: React.FC<AvatarProps> = ({
  avatar,
  icon,
  size,
  initials,
  initialsColorSeed,
  className,
}) => {
  const [binarySrc, setBinarySrc] = useState<string>()
  const hasBinaryAvatar = isDataBinary(avatar)
  const stringSrc = isString(avatar) ? avatar : undefined

  useEffect(() => {
    if (!hasBinaryAvatar) return
    let cancelled = false
    dataBinaryToUrl(avatar).then(({ url }) => {
      if (!cancelled) setBinarySrc(url)
    })
    return () => {
      cancelled = true
    }
  }, [avatar, hasBinaryAvatar])

  const src = hasBinaryAvatar ? binarySrc : stringSrc

  return (
    <AvatarProfile
      src={src}
      icon={icon}
      size={size}
      initials={initials}
      initialsColorSeed={initialsColorSeed}
      className={className}
    />
  )
}
